import { onSnapshot, query, collection, where } from 'firebase/firestore'
import { db } from 'controllers/db'
import { IFree } from 'shared/types'
import { receiveFrees } from 'model/actions'
import store from 'model/store'

export const dbFetchFrees = async () => {
  try {
    const q = query(collection(db, 'free'), where('invisible', '==', false))
    onSnapshot(
      q,
      sn => {
        const res: Record<string, IFree> = {}
        sn.forEach(doc => {
          const p = doc.data() as IFree
          res[doc.id] = { ...p, id: doc.id }
        })
        store.dispatch(receiveFrees(res))
      },
      err => {
        console.log(`dbFetchFrees error: ${err.message}`)
      }
    )
  } catch (e) {
    console.error('dbFetchFrees error', e)
  }
}
